// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"style__footerWrapper__Hssf-","footerInner":"style__footerInner__GIML8"};